import React from 'react'
import * as Fields from 'support/fields'
import { Fieldset } from 'layouts/index'
import EditFormSmartview from 'widgets/smartviews/partials/EditFormSmartview'
import SmartviewHeader from 'widgets/smartviews/partials/SmartviewHeader'
import IntegerConverterField from 'support/fields/IntegerConverterField'
import { Pipeline } from '@morningtrain/react-helpers'
import { ExecuteOperationOnPipe, ResetFormOnPipe, TriggerPipelineOnFormSubmit } from '@morningtrain/react-resources'

export default class CreateDomainSmartview extends EditFormSmartview {
  static get defaultProps () {
    return {
      ...super.defaultProps,
      goBackOnClickOutside: true
    }
  }

  get resourceName () {
    return 'domains'
  }

  get heading () {
    return 'Opret domæne'
  }

  get fields () {
    return (
      <>
        <SmartviewHeader>
          {this.heading}
        </SmartviewHeader>
        <Fieldset cols={1}>
          <Fields.Input name='domain' label='Domæne' />
          <Fields.Input name='description' label='Beskrivelse' />
          <IntegerConverterField name='price' label='Pris' step={0.01} min={0.01} />
          <Fields.Select
            name='status'
            enum='domain_status'
            placeholder='Vælg status'
            label='Status'
            defaultValue='active'
          />
        </Fieldset>
        <Pipeline>
          <TriggerPipelineOnFormSubmit />
          <ExecuteOperationOnPipe operationName='index' />
          <ResetFormOnPipe />
        </Pipeline>
      </>
    )
  }
}
